const BaseView = require('./view');

module.exports = BaseView.extend({
    events: Odigeo._.merge({
        'tap .cta_confirm:not(.cta_disabled)': 'onSelectBaggage',
        'tap .close_drawer': 'onClose',
    }, BaseView.prototype.events),
});
